import React from 'react';
import StateSocialWorkerJobsPage from './StateSocialWorkerJobsPage';

const FloridaSocialWorkerJobs = () => {
  return (
    <StateSocialWorkerJobsPage
      stateName="Florida"
      stateAbbr="FL"
      metaTitle="Florida Social Worker Jobs (LMSW, LCSW, MSW) | INeedASocialWorker"
      metaDescription="Find Florida social worker jobs in hospitals, hospice, schools, behavioral health, and community agencies. Search Miami, Orlando, Tampa jobs. Apply fast."
      cities={[
        "Miami",
        "Orlando",
        "Tampa",
        "Jacksonville",
        "Fort Lauderdale",
        "St. Petersburg",
        "Hialeah",
        "Tallahassee",
        "Cape Coral",
        "Fort Myers",
        "Pembroke Pines",
        "Hollywood",
        "Gainesville"
      ]}
      stateDescription="Looking for social work jobs in Florida? The Sunshine State has a rapidly growing healthcare industry with high demand for hospice, hospital, and behavioral health social workers."
      faqItems={[
        {
          question: "What types of social work jobs are hiring in Florida right now?",
          answer: "Florida employers commonly hire for hospice/palliative care, hospital social work, behavioral health, geriatric care, and community services. The aging population creates strong demand for healthcare social workers."
        },
        {
          question: "What license do I need to practice social work in Florida?",
          answer: "Florida requires the LCSW (Licensed Clinical Social Worker) for clinical practice and the LMSW (Licensed Master Social Worker) for non-clinical roles. BSW graduates can obtain the LBSW credential."
        },
        {
          question: "What is the average salary for social workers in Florida?",
          answer: "Florida social workers typically earn $45,000-$75,000+ depending on setting, experience, and location. South Florida and Orlando metros often offer higher compensation due to cost of living."
        },
        {
          question: "How do I apply faster?",
          answer: "Create your profile, upload your resume, and use one-click apply when available through our SW Express Apply™ feature."
        }
      ]}
    />
  );
};

export default FloridaSocialWorkerJobs;
